export default __webpack_public_path__ + "static/media/slot.ab131f98.svg";